import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import DocumentUploadForm from "@/components/documents/DocumentUploadForm";
import UploadSuccessView from "@/components/documents/UploadSuccessView";
import type { DocumentUploadResponse } from "@/types/document";

export default function DocumentUploadPage() {
  const navigate = useNavigate();
  const [uploadResult, setUploadResult] = useState<{
    documentId: string;
    data: DocumentUploadResponse;
  } | null>(null);

  if (uploadResult) {
    return (
      <div className="space-y-5">
        <div className="flex items-center gap-3">
          <button
            onClick={() => setUploadResult(null)}
            className="rounded-lg border border-gray-300 p-2 hover:bg-gray-50"
          >
            <ArrowLeft className="h-4 w-4" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Hasil Upload</h1>
            <p className="text-sm text-gray-500 mt-0.5">
              Dokumen berhasil disimpan
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <UploadSuccessView
            data={uploadResult.data}
            onViewDocument={() =>
              navigate(`/documents/${uploadResult.documentId}`)
            }
            onUploadAnother={() => setUploadResult(null)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate("/documents")}
          className="rounded-lg border border-gray-300 p-2 hover:bg-gray-50"
        >
          <ArrowLeft className="h-4 w-4" />
        </button>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Tambah Dokumen</h1>
          <p className="text-sm text-gray-500 mt-0.5">
            Isi metadata dan unggah file dokumen
          </p>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <DocumentUploadForm
          onSuccess={(id, result) => {
            if (result) {
              setUploadResult({ documentId: id, data: result });
            } else {
              navigate(`/documents/${id}`);
            }
          }}
          onCancel={() => navigate("/documents")}
        />
      </div>
    </div>
  );
}
